var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 0.5V11.125H35.5L23.8333 0.5ZM20.9167 11.125V0.5H4.875C2.45872 0.5 0.5 2.28384 0.5 4.48438V39.0156C0.5 41.2153 2.45872 43 4.875 43H31.125C33.5413 43 35.5 41.2162 35.5 39.0156V13.7812H23.9154C22.2201 13.7812 20.9167 12.5942 20.9167 11.125ZM25.2917 35.0312H10.7083C9.90625 35.0312 9.25 34.4336 9.25 33.7031C9.25 32.9727 9.90625 32.375 10.7083 32.375H25.2917C26.097 32.375 26.75 32.9695 26.75 33.7031C26.75 34.4336 26.0938 35.0312 25.2917 35.0312ZM25.2917 29.7188H10.7083C9.90625 29.7188 9.25 29.1211 9.25 28.3906C9.25 27.6602 9.90625 27.0625 10.7083 27.0625H25.2917C26.097 27.0625 26.75 27.657 26.75 28.3906C26.75 29.1211 26.0938 29.7188 25.2917 29.7188ZM26.75 23.0781C26.75 23.8086 26.0938 24.4062 25.2917 24.4062H10.7083C9.90625 24.4062 9.25 23.8086 9.25 23.0781C9.25 22.3477 9.90625 21.75 10.7083 21.75H25.2917C26.0938 21.75 26.75 22.3477 26.75 23.0781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/iconFile.cd0e8ed70280b3e7096dab139256e492.svg";
export { ForwardRef as ReactComponent };